import React, { useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";

const StudentViewCreditNotes = ({ creditNotes }) => {

  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        enableSorting: true,
        enableHiding: true,
        size: 40,
        cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "creditNotesDate",
        enableHiding: true,
        header: "Credit Notes Date",
        size: 120,
        Cell: ({ cell }) => formatDate(cell.getValue()),
      },
      {
        accessorKey: "referenceNo",
        enableHiding: true,
        header: "Reference No",
        size: 120,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "remark",
        enableHiding: true,
        header: "Remark",
        size: 150,
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "description",
        enableHiding: true,
        header: "Description",
        size: 150,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "creditAmount",
        enableHiding: true,
        header: "Credit Amount",
        size: 100,
        Cell: ({ cell }) => (cell.getValue() ? `$${cell.getValue().toFixed(2)}` : "N/A"),
      },
      {
        accessorKey: "usedAmount",
        enableHiding: true,
        header: "Used Amount",
        size: 100,
        Cell: ({ cell }) => (cell.getValue() ? `$${cell.getValue().toFixed(2)}` : "N/A"),
      },
      {
        accessorKey: "outstandingAmount",
        enableHiding: true,
        header: "Outstanding Amount",
        size: 120,
        Cell: ({ cell }) => (cell.getValue() ? `$${cell.getValue().toFixed(2)}` : "N/A"),
      },
      {
        accessorKey: "receiptNo",
        enableHiding: true,
        header: "Receipt No.",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "N/A",
      },
      {
        accessorKey: "createdAt",
        header: "Created At",
        size: 100,
        Cell: ({ cell }) => formatDate(cell.getValue()) || "",
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "updatedAt",
        header: "Updated At",
        size: 100,
        Cell: ({ cell }) => formatDate(cell.getValue()) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ],
    []
  );

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            "&.Mui-disabled .MuiSwitch-track": {
              backgroundColor: "#f5e1d0",
              opacity: 1,
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "#eb862a",
            },
          },
          track: {
            backgroundColor: "#e0e0e0",
          },
          thumb: {
            color: "#eb862a",
          },
          switchBase: {
            "&.Mui-checked": {
              color: "#eb862a",
            },
            "&.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#eb862a",
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <MaterialReactTable
        columns={columns}
        data={creditNotes || []} // Use creditNotes prop with fallback to empty array
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        initialState={{
          columnVisibility: {
            createdBy: false,
            createdAt: false,
            updatedBy: false,
            updatedAt: false,
            remark: false,
          },
        }}
        muiTableBodyRowProps={({ row }) => ({
          onClick: () => navigate(`/creditNoteHistory`),
          style: { cursor: "pointer" },
        })}
        renderEmptyRowsFallback={() => (
          <div className="text-center py-4">No credit notes available.</div>
        )}
      />
    </ThemeProvider>
  );
};

export default StudentViewCreditNotes;